import { render, staticRenderFns } from "./FlexListTable.vue?vue&type=template&id=601b5085&scoped=true"
import script from "./FlexListTable.vue?vue&type=script&lang=js"
export * from "./FlexListTable.vue?vue&type=script&lang=js"
import style0 from "./FlexListTable.vue?vue&type=style&index=0&id=601b5085&prod&lang=scss"
import style1 from "./FlexListTable.vue?vue&type=style&index=1&id=601b5085&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601b5085",
  null
  
)

export default component.exports